import { inject, Injectable } from '@angular/core';
import { TableService } from '@shared/components/table/table.service';

@Injectable({
  providedIn: 'root',
})
export class ActionsMenuService {
  private readonly _tableSvc = inject(TableService);

  public handleActionsMenu(actionsMenu: string[], callback: () => void, isAlta: { set: (value: boolean) => void }): void {
    // Si no existe 'CONSULTA', bloquea el código restante
    if (!actionsMenu.includes('CONSULTA')) {
      this._tableSvc.setIsConsulta(false);
      return;
    }

    this._tableSvc.setIsConsulta(true);

    const actionMap: Record<string, (state: boolean) => void> = {
      ALTA: isAlta.set.bind(isAlta),
      BAJA: this._tableSvc.setIsEliminar.bind(this._tableSvc),
      EXPORTAR: this._tableSvc.setIsExport.bind(this._tableSvc),
      MODIFICA: this._tableSvc.setIsModificar.bind(this._tableSvc),
      EJECUTAR: this._tableSvc.setIsIconVert.bind(this._tableSvc),
      VISUALIZAR: this._tableSvc.setIsVisualizar.bind(this._tableSvc),
    };

    Object.keys(actionMap).forEach((action) => {
      actionMap[action](actionsMenu.includes(action));
    });

    // Ejecutar el callback, que puede ser cualquier función pasada como parámetro
    callback();
  }
}
